<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="700px"
  >
    <template slot="dialogTitle">
      Mass import packs from Google Sheets
    </template>

    <v-card-text :class="{'px-5 pt-6 pb-12': !$vuetify.breakpoint.xsOnly }">
      <div v-if="result">
        <p>Mass import has been run successfully. Click any equipment pack to edit it directly:</p>

        <v-row
          v-for="pack in result"
          :key="pack.label"
          no-gutters
          class="list--bordered pa-3"
        >
          <v-col>
            <div v-if="!pack.id">
              {{ pack.label }}
            </div>
            <a
              v-else
              @click="doEditPack(pack.id)"
            >
              {{ pack.label }}
            </a>
            <div
              v-if="pack.status === 'failed' && pack.reason"
              class="caption error--text"
            >
              {{ pack.reason }}
            </div>
          </v-col>
          <v-col cols="auto">
            <v-chip
              small
              dark
              class="ma-0"
              :color="pack.status === 'created' ? 'success' : (pack.status === 'failed' ? 'error' : 'orange darken-2')"
            >
              {{ pack.status | capitalize }}
            </v-chip>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="submitting">
        <div class="text-center">
          <v-progress-circular
            :size="100"
            :width="2"
            color="primary"
            indeterminate
          />
        </div>
        <div class="text-center subtitle-1 mt-6">
          Running import...
        </div>
      </div>
      <v-row
        v-else
        no-gutters
        align="center"
      >
        <v-col class="body-1">
          Use this Google Sheets with the template to mass import equipment packs
        </v-col>
        <v-col cols="auto">
          <v-btn
            href="https://docs.google.com/spreadsheets/d/1VHGG-S5u26WKM6OG6SRavdp-DUNuqN02aQD9708M2hc/edit#gid=2135475686"
            target="_blank"
            color="primary"
            outlined
          >
            Go to Google Sheet
            <v-icon
              right
              small
            >
              arrow_forward
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <yacht-equipment-pack-edit-dialog
      v-if="editPack.pack"
      :yacht-equipment-pack="editPack.pack"
      :visible.sync="editPack.visible"
    />

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        :loading="submitting"
        @click="runImport()"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Run import
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import ContentDialog from '@/components/helpers/Dialog'
import YachtEquipmentPack from '@/models/YachtEquipmentPack'
import YachtEquipmentPackEditDialog from '@/components/settings/yachtEquipmentPacks/YachtEquipmentPackEditDialog'

export default {
    name: 'YachtEquipmentPacksImportDialog',
    components: {
      YachtEquipmentPackEditDialog,
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        submitting: false,
        result: undefined,
        editPack: {
          visible: false,
          pack: undefined
        }
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    created() {
    },
    methods: {
      async runImport() {
        this.result = undefined
        this.submitting = true

        try {
          this.result = await YachtEquipmentPack.api.massImport()

          this.$store.dispatch('alert', {
            text: 'Import went through - check the report',
            color: 'success'
          })

          this.$emit('imported')
        } catch (e) {
          this.$store.dispatch('alert', {
            text: 'Something went wrong with the import',
            color: 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      },
      async doEditPack(id) {
        try {
          this.editPack.pack = await YachtEquipmentPack.api.find(id)
          this.editPack.visible = true
        } catch (e) {

        }
      }
    }
  }
</script>
